<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :clip-path="`url(#${componentId}_clip0_4224_1694)`">
      <path
        d="M3.91971 7.30959C9.97305 6.89857 14.145 6.89439 20.0105 7.31154C21.3985 7.41026 22.5425 8.52969 22.7078 10.0029C23.1096 13.5881 23.0894 16.3379 22.6941 19.9727C22.5323 21.4604 21.3833 22.5984 19.9822 22.6963C14.0651 23.1096 9.89415 23.0935 3.93143 22.6963C2.46914 22.5988 1.2888 21.3731 1.18143 19.8145C0.945755 16.3933 0.934374 13.7079 1.1785 10.1807C1.2862 8.62767 2.46275 7.40876 3.91971 7.30959ZM8.49979 13C7.67141 13.0001 6.99982 13.6716 6.99979 14.5V15.5C6.99979 16.3284 7.67139 17 8.49979 17C9.32822 17 9.99979 16.3284 9.99979 15.5V14.5C9.99976 13.6716 9.3282 13 8.49979 13ZM15.4998 13C14.6714 13.0001 13.9998 13.6716 13.9998 14.5V15.5C13.9998 16.3284 14.6714 17 15.4998 17C16.3282 17 16.9998 16.3284 16.9998 15.5V14.5C16.9998 13.6716 16.3282 13 15.4998 13Z"
        fill="#D9D9D9"
      />
      <path
        d="M3.91971 7.30959C9.97305 6.89857 14.145 6.89439 20.0105 7.31154C21.3985 7.41026 22.5425 8.52969 22.7078 10.0029C23.1096 13.5881 23.0894 16.3379 22.6941 19.9727C22.5323 21.4604 21.3833 22.5984 19.9822 22.6963C14.0651 23.1096 9.89415 23.0935 3.93143 22.6963C2.46914 22.5988 1.2888 21.3731 1.18143 19.8145C0.945755 16.3933 0.934374 13.7079 1.1785 10.1807C1.2862 8.62767 2.46275 7.40876 3.91971 7.30959ZM8.49979 13C7.67141 13.0001 6.99982 13.6716 6.99979 14.5V15.5C6.99979 16.3284 7.67139 17 8.49979 17C9.32822 17 9.99979 16.3284 9.99979 15.5V14.5C9.99976 13.6716 9.3282 13 8.49979 13ZM15.4998 13C14.6714 13.0001 13.9998 13.6716 13.9998 14.5V15.5C13.9998 16.3284 14.6714 17 15.4998 17C16.3282 17 16.9998 16.3284 16.9998 15.5V14.5C16.9998 13.6716 16.3282 13 15.4998 13Z"
        :fill="`url(#${componentId}_paint0_linear_4224_1694)`"
      />
      <foreignObject
        x="8.16273"
        y="-0.837272"
        width="7.67454"
        height="10.6745"
      ><div
        xmlns="http://www.w3.org/1999/xhtml"
        :style="`backdrop-filter: blur(0.42px); clip-path: url(#${componentId}_bgblur_1_4224_1694_clip_path); height: 100%; width: 100%`"
      /></foreignObject>
      <g :filter="`url(#${componentId}_filter0_i_4224_1694)`" data-figma-bg-blur-radius="0.837272">
        <path
          d="M12 0C13.6569 0 15 1.34315 15 3C15 4.30574 14.1645 5.41299 13 5.8252V8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8V5.8252C9.83548 5.41299 9 4.30574 9 3C9 1.34315 10.3431 0 12 0Z"
          fill="#D9D9D9"
        />
        <path
          d="M12 0C13.6569 0 15 1.34315 15 3C15 4.30574 14.1645 5.41299 13 5.8252V8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8V5.8252C9.83548 5.41299 9 4.30574 9 3C9 1.34315 10.3431 0 12 0Z"
          :fill="`url(#${componentId}_paint1_linear_4224_1694)`"
          fill-opacity="0.6"
        />
      </g>
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_i_4224_1694`"
        x="8.16273"
        y="-0.837272"
        width="7.67454"
        height="10.6745"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="0.047683" dy="0.0238415" />
        <feGaussianBlur stdDeviation="0.119208" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4224_1694" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_1_4224_1694_clip_path`" transform="translate(-8.16273 0.837272)">
        <path
          d="M12 0C13.6569 0 15 1.34315 15 3C15 4.30574 14.1645 5.41299 13 5.8252V8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8V5.8252C9.83548 5.41299 9 4.30574 9 3C9 1.34315 10.3431 0 12 0Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_4224_1694`"
        x1="7.23262"
        y1="21.3228"
        x2="11.9342"
        y2="4.57188"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9BF8F4" />
        <stop offset="1" stop-color="#6F7BF7" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_4224_1694`"
        x1="9"
        y1="4"
        x2="15"
        y2="4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9BF8F4" />
        <stop offset="1" stop-color="#6F7BF7" />
      </linearGradient>
      <clipPath :id="`${componentId}_clip0_4224_1694`">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
